import merge from 'lodash/merge';
import BackboneElement from './BackboneElement';
import BN_Asam4LevelOfCareCriteriaTerminologyCriteria from './BN_Asam4LevelOfCareCriteriaTerminologyCriteria';

export default class BN_Asam4LevelOfCareCriteriaTerminologyTransition extends BackboneElement {
    static __className = 'BN_Asam4LevelOfCareCriteriaTerminologyTransition';

    __objectStructure = {
        type: String,
        id: String,
        criteria: [BN_Asam4LevelOfCareCriteriaTerminologyCriteria],
    };

    constructor(constructJson, className = 'BN_Asam4LevelOfCareCriteriaTerminologyLevel') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
